import { render } from "./MarketPlaceStoriesCarousal.vue?vue&type=template&id=b9ef3768"
import script from "./MarketPlaceStoriesCarousal.vue?vue&type=script&lang=js"
export * from "./MarketPlaceStoriesCarousal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__